<template>
  <div class="container presentation-container page-content">
    <header style="background-color: #05689a;height: auto;width: 100%;padding: 25px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img v-if="getApplicantType === 'Mercer'" src="../../../public/assets/images/mercer-logo-white.png"  alt="Logo">
          <img v-else-if="getApplicantType === 'Realshield'" src="../../../public/assets/images/realshield-logo-white.png"  alt="Logo">
          <img v-else src="../../../public/assets/images/orep-white-logo.png"  alt="Logo">
        </div>
      </div>
    </header>
    <div style="padding-left: 50px;padding-right: 50px;padding-top: 20px;">

      <div class="row">
        <div class="col-md-8">
          <p class="comic-font-bold" style="font-size: 30px; color: #05689a">
            <img src="">
            <strong>SECURE PAYMENT PROCESSING</strong>
          </p>
          <p class="comic-font-bold" style="font-size: 30px;">
            PREMIUM PROPOSAL
          </p>
        </div>
        <div class="col-md-auto text-center">
          <img v-if="getApplicantType === 'Mercer'" src="../../../public/assets/images/mercer-call.png"  class="w-100" alt="18 years">
          <img v-else-if="getApplicantType === 'Realshield'" src="../../../public/assets/images/mercer-call.png"  class="w-100" alt="18 years">
          <img v-else src="../../../public/assets/images/call-1.png" class="w-100" alt="18 years">
        </div>
      </div>
      <hr class="new1" />

      <div class="row justify-content-center" style="margin-top: 30px">
        <div class="col-md-10 text-left">
          <div class="row">
            <div class="col-md-auto text-center">
              <p class="comic-font-bold" style="font-size: 20px;">
                PREMIUM PREPARED FOR: {{ axApplication.fullLegalNameOfAppraiser }}
              </p>
            </div>
          </div>

          <hr class="new1">
        </div>
      </div>
      <div class="row justify-content-center" style="margin-top: 20px">
        <div class="col-md-10 text-left">
          <table class="w-100">
            <tbody>
            <tr>
              <td>
                <p class="comic-font-bold" style="color: #05689a">
                  <strong>LIMITS OF COVERAGE:</strong>
                </p>
              </td>
              <td>
                <input type="text" :placeholder=coverage()   class="w-100" disabled>
              </td>
            </tr>
            <tr>
              <td style="margin-bottom: 3rem !important;">
                <strong>Deductible:</strong>
              </td>
              <td>
                <input placeholder="$0 (by OREP Membership endorsement)" class="w-100" disabled>
              </td>
            </tr>

            <tr>
              <td>
                <p class="comic-font-bold" style="color: #05689a">
                  <strong>PREMIUM:</strong>
                </p>
              </td>
              <td>
                <input type="text" :placeholder="'$'+(state.premium).toFixed(2)"   class="w-100" disabled>
              </td>
            </tr>
            <tr>
              <td>
                <strong>OREP Member Fee:</strong>
              </td>
              <td>
                <input :placeholder="'$'+orepfee().toFixed(2)" class="w-100" disabled>
              </td>
            </tr>

            <tr v-if="axApplication.traineeCoverage">
              <td>
                <strong>Appraiser Trainee Coverage:</strong>
              </td>
              <td>
                <input type="text" :placeholder="'$'+(state.premiumTraineeCoverage).toFixed(2)"   class="w-100" disabled>
              </td>
            </tr>
            <tr  v-if="axApplication.mgmtCoverage">
              <td>
                <strong>Real Estate AMC Extension:</strong>
              </td>
              <td>
                <input :placeholder="'$'+(state.premiumMgmtCoverage).toFixed(2)" class="w-100" disabled>
              </td>
            </tr>
            <tr  v-if="axApplication.customer.state == 'CT' || axApplication.customer.state == 'NY' || axApplication.customer.state == 'FL' || axApplication.customer.state == 'NJ'  || axApplication.customer.state == 'MA' || axApplication.customer.state == 'KY'">
              <td>
                <strong>State Tax:</strong>
              </td>
              <td>
                <input v-if = "state.stateTax == '0'" :placeholder="'Agent to Calculate'" class="w-100" disabled>
                <input v-else :placeholder="'$'+(state.stateTax).toFixed(2)" class="w-100" disabled>
              </td>
            </tr>
            <tr>
              <td>
                <p class="comic-font-bold" style="color: #05689a">
                  <strong>TOTAL:</strong>
                </p>
              </td>
              <td>
                <input :placeholder="'$'+(total()+orepfee()).toFixed(2)" class="w-100" disabled>
              </td>
            </tr>

            </tbody>
          </table>
        </div>
      </div>

      <div class="row justify-content-center" style="margin-top: 30px">
        <div class="col-md-10 text-left">
          <div class="row">
            <div class="col-md-auto text-left">
              <p>
                <strong>
                  <i>Please Note:</i>
                </strong>
                Your Insurance Policy is not in effect/bound until Payment or Down-Payment is received. <strong style="text-decoration: underline">To expedite coverage and avoid delays, please use one of these two links to make payment now.</strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <hr class="new1" />

      <div class="col text-center" style="margin-top: 50px;background-color:  #05689a">
        <p class="comic-font-bold" style="font-size: 25px; color: white">
          SELECT PAYMENT TYPE
        </p>
      </div>

      <div style="margin-top: 30px;margin-bottom: 50px;" class="payment-type-wrapper">
        <div>
          <div class="radio-button ">
            <div class="radio-button row justify-content-center">
              <div>
                <input  type="radio" id="radio1" name="radios" :value=false v-model="state.paymentType" checked>
                <label for="radio1" class="radio1">
                  <i class="fa fa-bank fa-3x"></i>
                  <p class="comic-font-bold" style="margin-bottom: 1rem !important;">
                    <strong>Debit Card / ACH</strong>
                  </p>
                  <img
                    src="../../../public/assets/images/SSL_blue.png"
                    height="50"
                    width="100"
                    alt="SSL image"
                  >
                  <p class="text-left" style="margin-bottom: 1rem !important;">
                    <strong>Amount: ${{ (total()+orepfee()).toFixed(2) }}</strong>
                  </p>
                  <p class="text-left" style="margin-bottom: 1rem !important;">
                    <strong>Fee: $0.00</strong>
                  </p>
                  <p class="text-left" style="font-size: 20px; margin-bottom: 1rem !important;">
                    <strong>Total: ${{ (total()+orepfee()).toFixed(2) }}</strong>
                  </p>
                  <p class="text-left comic-font-bold" style="font-size: 16px;color: #05689a;">
                    No Processing Fee
                  </p>
                  <p class="text-left" style="margin-bottom: 1rem !important;">
                    for Debit Card or ACH
                  </p>
                </label>
              </div>

              <div>
                <input type="radio" id="radio2" name="radios" :value=true v-model="state.paymentType">
                <label for="radio2">
                  <i class="fa fa-credit-card fa-3x"></i>
                  <p class="comic-font-bold" style="margin-bottom: 1rem !important;">
                    <strong>Credit Card</strong>
                  </p>


                  <img
                    src="../../../public/assets/images/SSL_blue.png"
                    height="50"
                    width="100"
                    alt="background image"
                  >
                  <p class="text-left" style="margin-bottom: 1rem !important;">
                    <strong>Amount: ${{ (total()+orepfee()).toFixed(2) }}</strong>
                  </p>
                  <p class="text-left" style="margin-bottom: 1rem !important;">
                    <strong>Fee: ${{ processing_fee().toFixed(2) }}</strong>
                  </p>
                  <p class="text-left" style="font-size: 20px;margin-bottom: 1rem !important;">
                    <strong>Total: ${{ (processing_fee() + total()+orepfee()).toFixed(2) }} </strong>
                  </p>
                  <p class="text-left comic-font-bold" style="font-size: 16px;color: #05689a;">
                    1.9% Processing Fee
                  </p>
                  <p class="text-left" style="margin-bottom: 1rem !important;">
                    Lowest in the Industry!
                  </p>
                </label>
              </div>

            </div>
          </div>
        </div>
      </div>
      <hr class="new1" />
      <div v-show="state.paymentType === true" class="align-content-center text-center" style="margin-top: 30px;margin-bottom: 50px;">
        <div >
            <form :action=getAsecureCartUrl()  target="_blank" method="POST" name="frm">
              <input name="TaxItem" type="hidden" value="n">
              <input name="AddEmail" type="hidden" value="appraisers@orep.org">
              <input v-if="getApplicantType === 'Mercer' || getApplicantType === 'Realshield'" name="AddEmail" type="hidden" value="isaacfpeck@gmail.com">
              <input name="ID" type="hidden" value="Premium">
              <input name="ID" type="hidden" value="State Tax">
              <input name="ID" type="hidden" value="OREP Fee">
              <input name="ID" type="hidden" value="Processing Fee">
              <input name="Price" type="hidden" :value="(totalPremium()).toFixed(2)">
              <input name="Price" type="hidden" :value="(state.stateTax).toFixed(2)">
              <input name="Price" type="hidden" :value="(orepfee()).toFixed(2)">
              <input name="Price" type="hidden" :value="(processing_fee()).toFixed(2)">
              <input name="Multi" type="hidden" value="Y">
              <input class="text-uppercase text-center comic-font-bold proceed-to-payment" name="Submit" type="submit" value="PROCEED TO PAYMENT">
            </form>
      </div>
        <a href="https://orep.org/google-reviews/" target="_blank">
        <img
          src="../../../public/assets/images/vcr_large.png"
          height="115"
          width="150"
          alt="SSL image"
        >
        </a>
        <img
          src="../../../public/assets/images/SecureSSLEncryption.png"
          height="150"
          width="150"
          alt="SSL image"
        >
        <div>

        </div>
      </div>
      <div v-show="state.paymentType === false" class="align-content-center text-center" style="margin-top: 30px;margin-bottom: 50px;">
        <div >
          <form :action=getAsecureCartUrl() target="_blank" method="POST" name="frm1">
            <input name="TaxItem" type="hidden" value="n">
            <input name="AddEmail" type="hidden" value="appraisers@orep.org">
            <input v-if="getApplicantType === 'Mercer' || getApplicantType === 'Realshield'" name="AddEmail" type="hidden" value="isaacfpeck@gmail.com">
            <input name="ID" type="hidden" value="Premium">
            <input name="ID" type="hidden" value="State Tax">
            <input name="ID" type="hidden" value="OREP Fee">
            <input name="Price" type="hidden" :value="(totalPremium()).toFixed(2)">
            <input name="Price" type="hidden" :value="state.stateTax.toFixed(2)">
            <input name="Price" type="hidden" :value="(orepfee()).toFixed(2)">
            <input name="Multi" type="hidden" value="Y">
            <input class="text-uppercase text-center comic-font-bold proceed-to-payment" name="Submit" type="submit" value="PROCEED TO PAYMENT">
          </form>
        </div>
        <a href="https://orep.org/google-reviews/" target = "_blank">
        <img
          src="../../../public/assets/images/vcr_large.png"
          height="115"
          width="150"
          alt="SSL image"
        >
        </a>
        <img
          src="../../../public/assets/images/SecureSSLEncryption.png"
          height="150"
          width="150"
          alt="SSL image"
        >
        <div>

        </div>
      </div>
    </div>

    <footer v-if="getApplicantType === 'Mercer'" style="background-color: #05689a;height: auto;width: 100%;padding: 40px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img src="../../../public/assets/images/mercer-logo-white.png" class="w-100" alt="Logo">
        </div>
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            AMBA
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            PO Box 4050 NW 114th Street, Bldg 19
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Urbandale, IA  50322
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            1-866-795-9613
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            amba.service@amba.info
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Association Member Benefits Advisors, LLC. In CA d/b/a
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Association Member Benefits & Insurance Agency
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            CA Insurance License #0I96562
          </p>
        </div>
      </div>

    </footer>
    <footer v-else-if="getApplicantType === 'Realshield'" style="background-color: #05689a;height: auto;width: 100%;padding: 40px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img src="../../../public/assets/images/realshield-logo-white.png" class="w-100" alt="Logo">
        </div>
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            AMBA
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            PO Box 4050 NW 114th Street, Bldg 19
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Urbandale, IA  50322
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            1-866-795-9613
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            amba.service@amba.info
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Association Member Benefits Advisors, LLC. In CA d/b/a
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Association Member Benefits & Insurance Agency
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            CA Insurance License #0I96562
          </p>
        </div>
      </div>

    </footer>
    <footer v-else style="background-color: #05689a;height: auto;width: 100%;padding: 40px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img src="../../../public/assets/images/orep-white-logo.png" class="w-100" alt="Logo">
        </div>
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            OREP Insurance Services, LLC || CA License #0K99465
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            6353 El Cajon Blvd, Suite 124-605
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            San Diego, CA 92115
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            (888) 347-5273
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            appraisers@OREP.org
          </p>
        </div>
      </div>

    </footer>
  </div>

</template>
<script>
import $ from 'jquery';
import moment from 'moment';

export default {

  name: 'ax-application-representation',
  created() {
    const params = this.$route.query;
    if (params && params.id) {
      console.log(Number(params.id));
      this.loading = true;
      this.$store.dispatch('axApplication/requestFinanceAgreement', { id: params.id });
      // this.$store.dispatch('ax-application/6/request-finance-agreement/');
    }
  },

  computed: {

    axApplication() {
      return this.$store.state.axApplication.axApplication;
    },
    state() {
      return this.$store.state.axApplication;
    },
    errorMsg() {
      return this.$store.state.axApplication.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/ax-application-amba' || first === '/portal/ax-application-amba/' || this.axApplication.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (first === '/portal/ax-application-realshield' || first === '/portal/ax-application-realshield/' || this.axApplication.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }else {
        return 'OREP';
      }
    },
  },
  // created: function(){
  //   if (this.state.premium == 0){
  //     window.location.href = "https://orep.org/appraiser-portal-payment/"
  //     // this.$router.push('https://orep.org/appraiser-portal-payment/')
  //   }
  // },
  methods: {
    getEffectiveDate() {
      return moment.utc(this.state.axApplication.effectiveDate).format('MM/DD/YYYY');
    },
    getAsecureCartUrl() {
      const effectiveDate = moment.utc(this.state.axApplication.effectiveDate).format('MM/DD/YYYY');
      // eslint-disable-next-line no-console
      if (effectiveDate >= '03/01/2023' && effectiveDate !== 'Invalid date') {
        return 'https://www.asecurecart.net/server/cart.aspx/workingre2';
      }
      return 'https://www.asecurecart.net/server/cart.aspx/workingre2';
    },

    totalPremium() {
      if (this.state.premium !== 0) {
        let total = this.state.premium;

        if (this.axApplication.firstCoverage) {
          total += this.state.premiumFirstCoverage;
        }
        if (this.axApplication.traineeCoverage) {
          total += this.state.premiumTraineeCoverage;
        }
        if (this.axApplication.mgmtCoverage) {
          total += this.state.premiumMgmtCoverage;
        }

        return total;
      }

      return 0;
    },
    total() {
      if (this.state.premium !== 0) {
        return this.totalPremium() + this.state.stateTax;
      }
      return 0;
    },
    processing_fee() {
      return ((this.total() + this.orepfee()) * 0.019);
    },
    coverage() {
      switch (this.axApplication.limitOfCoverage) {
        case '0.3M/0.6M':
          return '$300,000 / $600,000';
        case '0.5M/1M':
          return '$500,000 / $1,000,000';
        case '1M/1M':
          return '$1,000,000 / $1,000,000';
        default:
          return '$1,000,000 / $2,000,000';
      }
    },
    orepfee() {
      // if (this.axApplication.customer.state === 'CO' || this.axApplication.customer.state === 'FL') {
      if (this.axApplication.customer.state === 'CO') {
        return 60;
      }

      if (this.state.premium !== 0) {
        return 60;
      }

      return 60;
    },
  },

  mounted() {
    $('html, body').animate({
      scrollTop: $('.presentation-container').offset().top,
    }, 500);
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Open+Sans');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
.radio-button {
  margin: 15px;
}
.radio-button input[type="radio"] {
  opacity: 0;
  position: fixed;
  width: 0;
}
.radio-button label {
  display: inline-block;
  background-color: #ffffff;
  padding: 10px 40px;
  font-family: sans-serif, Arial;
  font-size: 16px;
  border: 1px solid #05689a;
  border-radius: 4px;
}
.radio-button label:hover {
  background-color: #05689a;
}

.radio-button input[type="radio"]:focus + label {
  border: 2px dashed #f1f1f1;
}
.radio-button input[type="radio"]:checked + label {
  background-color: #f1f1f1;
  border-color: #05689a;
}

.container {
  background-color: white !important;
  padding-right: 0px;
  padding-left: 0px;
}
.img-call {
  height: 170px;
  max-height: 170px;
}
p {
  margin: 5px 0;
}
.strong {
  font-weight: bold !important;
}
li{
  margin: 12px 0;
}
table td {
  padding: 0 5px 15px !important;
}
table > tbody > tr > td:first-child {
  width: 35%
}
table > tbody > tr > td:last-child {
  width: 65%
}


::placeholder {
  color: black;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: black;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: black;
}
.table-bordered td {
  vertical-align: top;
  border-right: 2px solid #dee2e6;
  border-left-width: 0;
  border-bottom-width: 0;
  border-top-width: 0;
}
* {
  box-sizing: border-box;
}

/* Create three unequal columns that floats next to each other */
.column {
  float: center;
  padding: 10px;
  height: 300px; /* Should be removed. Only for demonstration */
}

.left {
  width: 25%;
}
.right {
  width: 5%;
}

.middle {
  width: 63%;
}

.comic-font{
  font-family: 'Open Sans';
}
.comic-font-bold{
  font-family: 'Open Sans';
  font-weight: bold;
}
hr.new1 {
  border-top: 1px solid grey;
}
.no-gutter > [class*='col-'] {
  padding-right:0;
  padding-left:0;
}
</style>